import { render, staticRenderFns } from "./CompanyRating.vue?vue&type=template&id=eb60a930&scoped=true&"
import script from "./CompanyRating.vue?vue&type=script&lang=js&"
export * from "./CompanyRating.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRating.vue?vue&type=style&index=0&id=eb60a930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb60a930",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RatingStars: require('/home/circleci/repo/components/RatingStars.vue').default})
